var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreasinggraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357 95",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 84L53.6358 94.0487C55.1299 94.3339 56.6726 93.9235 57.8274 92.9336L91.5266 64.0486C93.2729 62.5518 95.8151 62.4394 97.6867 63.7762L123.03 81.8784C124.799 83.1423 127.183 83.1176 128.926 81.8173L185.915 39.3015C187.733 37.9449 190.237 37.9827 192.014 39.3936L236.267 74.5354C238.357 76.1951 241.382 75.9209 243.139 73.9124L298.275 10.9C299.065 9.99692 300.154 9.40813 301.342 9.24118L360 1",
    stroke: "url(#paint0_linear_6605_14588)",
    strokeWidth: 1.46183
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6605_14588",
    x1: 180.5,
    y1: 1,
    x2: 180.5,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FCF9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasinggraph);
export default __webpack_public_path__ + "static/media/increasinggraph.2e95fe2c67e8e59edf9eb47fdb66d28c.svg";
export { ForwardRef as ReactComponent };